import { FormGroup, InputGroup, Intent } from "@blueprintjs/core";
import { SingleInputType } from "utils/form";
import "./SingleFormInput.scss";

export default function SingleFormInput(props: SingleInputType & { inputRef?: React.RefObject<HTMLInputElement> }) {
  const {
    name,
    type,
    label,
    labelInfo,
    handleChange,
    error,
    className,
    helperText,
    element,
    intent,
    value,
    readOnly,
    maxLength,
    placeholder,
    inputRef,
  } = props;
  return (
    <FormGroup className={`${className} single-input`} label={label} labelFor={name} labelInfo={labelInfo}>
      <InputGroup
        maxLength={maxLength}
        intent={intent ? intent : error ? Intent.DANGER : Intent.NONE}
        name={name}
        value={value}
        type={type}
        readOnly={readOnly}
        onChange={handleChange}
        leftElement={element as JSX.Element}
        placeholder={placeholder}
        inputRef={inputRef}
      />
      {error ? <span className="red helperText">{error}</span> : <span className="grey helperText">{helperText}</span>}
    </FormGroup>
  );
}
